import { worldAssets } from '../lib/appAssets'

export interface World {
  slug: string
  name: string
  description: string
  art: string
  alt: string
  width: number
  height: number
}

/** One-line website descriptions, keyed by the app's world names. */
const descriptions: Record<string, string> = {
  'Amazing Animals': 'How animals eat, hide, hunt and survive, and what we get wrong about them.',
  'Space & Beyond': 'Planets, moons, rockets and the very strange rules of living without gravity.',
  'Your Incredible Body': 'What is happening under your own skin while you sit still and read this.',
  'Our Wild Earth': 'Mountains, rivers, forests and deserts, and how they slowly rearrange themselves.',
  'How Things Work': 'Zippers, locks, lightbulbs and elevators: the everyday machines nobody explains.',
  'Long Ago': 'How people actually lived, built and travelled before any of this existed.',
  'Ocean Secrets': 'Life in the dark, deep, salty parts of the planet we have barely visited.',
  'Dinosaur Days': 'What fossils really tell us, and what films quietly made up.',
  'Tiny Worlds': 'Insects, seeds, cells and other things too small to notice but too odd to ignore.',
  'Wild Weather': 'Where storms come from, why hail exists, and what lightning is doing up there.',
  'Food Adventures': 'Where dinner comes from, why bread rises, and what makes chilli feel hot.',
  'Machines on the Move': 'Trains, planes, ships and bikes, and the tricks that keep them upright.',
  'Art, Sound & Imagination': 'How colour, music and stories are made, and why they move us.',
  'Amazing Places & Cultures': 'Cities, festivals and everyday life in places a child has never been.',
  'Extreme Worlds': 'The hottest, coldest, highest and driest corners of the planet, and who lives there.',
  'Strange but True': 'The genuinely odd facts that sound invented, plus why they are not.',
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

/** World order and artwork come straight from the app manifest. */
export const worlds: World[] = worldAssets.map((asset) => ({
  slug: slugify(asset.name),
  name: asset.name,
  description: descriptions[asset.name] ?? '',
  art: asset.src,
  alt: asset.alt,
  width: asset.width,
  height: asset.height,
}))
